<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>积分套餐</span>
        <el-button type="primary" size="small" @click="openDialog()">新增套餐</el-button>
      </div>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="name" label="名称" min-width="120" />
        <el-table-column prop="points" label="积分" width="90" />
        <el-table-column prop="bonus" label="赠送" width="80" />
        <el-table-column prop="price" label="价格(元)" width="100" />
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="{ row }">{{ labelOf(COMMON_STATUS, row.status) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openDialog(row)">编辑</el-button>
            <el-button type="text" size="small" class="danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="form.id ? '编辑套餐' : '新增套餐'" :visible.sync="visible" width="460px">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="积分" prop="points">
          <el-input-number v-model="form.points" :min="1" style="width: 100%" />
        </el-form-item>
        <el-form-item label="赠送">
          <el-input-number v-model="form.bonus" :min="0" style="width: 100%" />
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input-number v-model="form.price" :min="0" :precision="2" style="width: 100%" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width: 100%">
            <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPointPackages, savePointPackage, deletePointPackage } from '@/api/admin'
import { COMMON_STATUS, labelOf, optionsOf } from '@/utils/adminConstants'

export default {
  name: 'AdminPoints',
  data() {
    return {
      COMMON_STATUS,
      loading: false,
      list: [],
      visible: false,
      submitting: false,
      form: { id: null, name: '', points: 100, bonus: 0, price: 0, status: 1 },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        points: [{ required: true, message: '请输入积分', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }]
      }
    }
  },
  computed: {
    statusOptions() {
      return optionsOf(COMMON_STATUS)
    }
  },
  created() {
    this.loadPackages()
  },
  methods: {
    labelOf,
    async loadPackages() {
      this.loading = true
      try {
        this.list = await getPointPackages() || []
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    openDialog(row) {
      this.form = row
        ? { ...row }
        : { id: null, name: '', points: 100, bonus: 0, price: 0, status: 1 }
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await savePointPackage(this.form)
          this.$message.success('保存成功')
          this.visible = false
          this.loadPackages()
        } catch (e) {
        } finally {
          this.submitting = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该套餐？', '提示', { type: 'warning' }).then(async () => {
        try {
          await deletePointPackage(row.id)
          this.$message.success('已删除')
          this.loadPackages()
        } catch (e) {
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.danger {
  color: #f56c6c;
}
</style>
